import React from "react";
import { AuthCallbackPage } from "@d-m-organization/hub-shared-lib/auth";
import { HubLayout } from "../components/HubLayout.js";

export function AuthCallback() {
  return <AuthCallbackPage wrapper={HubLayout} />;
}
